/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Tab_ActivityInputs */

const en_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

const de_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivität`)
};

const fr_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité`)
};

const es_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const it_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività`)
};

const nl_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteit`)
};

const pl_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywność`)
};

const fi_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toiminta`)
};

const da_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const sv_analytics_tab_activity = /** @type {(inputs: Analytics_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Analytics_Tab_ActivityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_tab_activity = /** @type {((inputs?: Analytics_Tab_ActivityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Tab_ActivityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_tab_activity(inputs)
	if (locale === "fr") return fr_analytics_tab_activity(inputs)
	if (locale === "es") return es_analytics_tab_activity(inputs)
	if (locale === "it") return it_analytics_tab_activity(inputs)
	if (locale === "nl") return nl_analytics_tab_activity(inputs)
	if (locale === "pl") return pl_analytics_tab_activity(inputs)
	if (locale === "fi") return fi_analytics_tab_activity(inputs)
	if (locale === "da") return da_analytics_tab_activity(inputs)
	if (locale === "sv") return sv_analytics_tab_activity(inputs)
	return en_analytics_tab_activity(inputs)
});